<template>
  <div>
    <el-row>
      <el-col :span="24">
        <span>课程评价</span>
        <el-input class="search-el" size="mini" v-model="query.title" clearable placeholder="请输入课程名称"></el-input>
        <el-input class="search-el" size="mini" v-model="query.mobile_phone" clearable placeholder="用户手机号"></el-input>
        <el-select class="search-el" size="mini" v-model="query.status" clearable placeholder="评价状态">
          <el-option label="评价状态" value="">评价状态</el-option>
          <el-option label="显示" value="1">显示</el-option>
          <el-option label="隐藏" value="2">隐藏</el-option>
        </el-select>
        <el-input class="search-el" size="mini" v-model="query.score_min" clearable placeholder="起始分数"></el-input>
        ~
        <el-input class="search-el" size="mini" v-model="query.score_max" clearable placeholder="终止分数"></el-input>
        <el-select class="search-el" size="mini" v-model="query.gift" clearable placeholder="全部">
          <el-option label="全部" value="">全部</el-option>
          <el-option label="有问卷奖励" value="1">有问卷奖励</el-option>
          <el-option label="无问卷奖励" value="2">无问卷奖励</el-option>
        </el-select>
        <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>
        <el-button type="primary" size="mini" @click="exportList()">
          导出评价内容
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
        <el-table-column label="id" align="center" min-width="3%" prop="id"></el-table-column>
        <el-table-column label="课程分类" align="center" min-width="5%" prop="type_msg"></el-table-column>
        <el-table-column label="课程信息" align="center" min-width="20%">
          <template slot-scope="{ row }">
            {{ row.target_id + '/' + row.title }}
          </template>
        </el-table-column>
        <el-table-column label="对应订单号" align="center" min-width="8%" prop="order_no"></el-table-column>
        <el-table-column label="用户信息" align="center" min-width="20%">
          <template slot-scope="{ row }">
            {{ (row.mobile_phone == null ? '' : row.mobile_phone) + '/' + row.nickname }}
          </template>
        </el-table-column>
        <el-table-column label="评价时间" align="center" min-width="8%" prop="created_at"></el-table-column>
        <el-table-column label="评分" align="center" min-width="5%" prop="course_score"></el-table-column>
        <el-table-column label="内容" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="showContent(row.evaluation_content)">
              {{ row.evaluation_content }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="问卷奖励内容" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <span v-if="row.satisfaction_score == null && row.practicality_score == null">无</span>
            <span v-else>
              <el-button type="text" size="mini" @click="showScore(row)">
                查看
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="是否获得奖励" align="center" min-width="8%" prop="gift_msg"></el-table-column>
        <el-table-column label="评价状态" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.is_show == 1" style="color: #67c23a;"><i class="el-icon-circle-check"></i> 显示</span>
              <span v-else style="color: #909399;"><i class="el-icon-circle-close"></i> 隐藏</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <div>
              <el-button type="text" size="mini" style="margin-left: 5px;" @click="
                row.is_show == 1
                  ? updateStatus(row.id, 0)
                  : updateStatus(row.id, 1)
                ">
                {{ row.is_show == 1 ? "隐藏" : "显示" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
        title="查看问卷奖励内容"
        :visible.sync="score.chooseOrgVisible"
        :close-on-click-modal="true"
        width="75%"
    >
      <el-table
          border
          :data="score.data"
          highlight-current-row
          style="..."
      >
        <el-table-column
            prop="satisfaction_score"
            label="课程满意度"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="practicality_score"
            label="课程实用性"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="professional_score"
            label="课程专业性"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="teacher_score"
            label="主讲老师评分"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="assistant_score"
            label="助教评分"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="banban_score"
            label="班班评分"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="study_effect_score"
            label="学习效果评分"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="study_atmosphere_score"
            label="学习氛围评分"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="study_experience_score"
            label="体验感评分"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="advice"
            label="课程学习建议"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="harvest"
            label="最大收获"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="recommend_phone"
            label="朋友联系方式"
            align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  evaluationList,
  evaluationStatus
} from "@/api/course";
import {
  formatDate,
} from "@/api/common";

const axios = require('axios');

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 10,
        title: "",
        mobile_phone: "",
        status: '',
        score_min: '',
        score_max: '',
        gift: '',
        export: 0
      },
      score: {
        chooseOrgVisible: false,
        data: [],
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    showScore(row) {
      this.score.chooseOrgVisible = true;
      this.score.data = [row];
    },
    showContent (content) {
      this.$alert(content, '评价内容', {
        confirmButtonText: '确定'
      });
    },
    getList () {
      this.loading = true;
      evaluationList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateStatus(id, status) {
      this.$confirm("是否将该评价设置为" + (status == 1 ? '显示？' : '隐藏？'), "温馨提示", {
        confirmButtonText: "确认修改",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        evaluationStatus({
          id: id,
          status: status,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          }
        });
      }).catch(() => {});
    },

    exportList () {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/course/evaluation/getList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        const link = document.createElement('a')
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '评价列表' + formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss') + '.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    }
  },
  mounted () { },
};
</script>